import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  InputAdornment,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import { Formik } from "formik";
import { useStyles } from "./styles";
import SearchIcon from "@mui/icons-material/Search";
import LendBooks from "./LendBooks/index";
import LendReturn from "./LendReturn/index";
import useLend from "../../../Hooks/lend";

import CustomExpandMore from "../../../common/CustomExpandMore";
import { useNavigate } from "react-router-dom";
import { TableLoader } from "../../../common/Loader";
import CustomPagination from "../../../common/Pagination";
import usePagination from "../../../common/usePagination";
import { CheckBox } from "@mui/icons-material";
import { style } from "d3";

const columns = [
  {
    id: "select",
    label: "Select",
    align: "center",
    sortby: true,
  },
  {
    id: "book",
    sortby: true,
    label: "Book Title",
    align: "center",
  },
  {
    id: "author",
    sortby: true,
    label: "Author",
    align: "center",
  },
  {
    id: "lendDate",
    label: "Lend Date",
    align: "center",
    sortby: true,
  },
  {
    id: "dueDate",
    label: "Due Date",
    align: "center",
    sortby: true,
  },
];

const LendList = () => {
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const [PerPage, setPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const {
    getBooksListInfo,
    bookList,
    bookTitle,
    loading,
    resetBookReturnListAction,
  } = useLend();
  const initValues = {
    title: "",
    studentId: "",
  };

  const handlePage = (e) => {
    setPerPage(e.target.value);
  };

  const count = bookList && Math.ceil(bookList?.totalNoOfRecordsForBooksToReturn?.totalNoOfRecords / PerPage);
  const _DATA = usePagination(bookList?.bookReturn, PerPage);

  const handleChange = useCallback(
    (e, p) => {
      setPage(p);
      setOffset(p * PerPage - PerPage);
      _DATA.jump(p);
    },
    [PerPage, page]
  );

  const [studentID, setStudentID] = useState("");
  const [BookData, setBookData] = useState({});
  const [selectedValue, setSelectedValue] = useState();

  useEffect(() => {
    resetBookReturnListAction();
  }, []);

  useEffect(() => { 
    getBooksListInfo({
      regNumber: studentID,
      limit: PerPage,
      offset: offset,
    })
  }, [PerPage, page, studentID]);

  const handleRadio = (data) => {
    setSelectedValue(data.id);
    setBookData(data);
  };

  return (
    <Stack className={classes.lend}>
      <Grid container>
        <Grid item lg={10} xl={10} sm={12}>
          <LendBooks />
          <Stack>
            <Box className={classes.cardGaps}>
              <Paper
                sx={{
                  width: "100%",

                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",
                }}
              >
                <Stack sx={{ p: 4 }}>
                  <Typography
                    sx={{ py: 2 }}
                    className={classes.add_course_text}
                  >
                    Lend Books List
                  </Typography>
                  <Grid container>
                    <Grid item lg={12} sm={12}>
                      <Stack>
                        <Stack
                          sx={{
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            py: 2,
                          }}
                          className={classes.lend}
                        >
                          <Typography
                            sx={{ marginRight: "50px", fontFamily: "inter" }}
                          >
                            Student ID
                          </Typography>
                          <TextField
                            id="studentId"
                            name="studentId"
                            placeholder="Search"
                            type={"text"}
                            value={studentID}
                            onChange={(e) => setStudentID(e.target.value)}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment
                                  position="start"
                                  // onClick={() =>
                                  //   getBooksListInfo({
                                  //     regNumber: studentID,
                                  //     limit: PerPage,
                                  //     offset: offset,
                                  //   })
                                  // }
                                  sx={{ cursor: "pointer" }}
                                >
                                  <SearchIcon />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Stack>
                        <TableContainer>
                          {loading ? (
                            <div>
                              <TableLoader />
                            </div>
                          ) : (
                            <Table
                              aria-label="sticky table"
                              className={classes.root}
                              style={{ padding: 0 }}
                            >
                              <TableHead>
                                <TableRow classes={{ root: classes.thead }}>
                                  {columns.map((column) => (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                      style={{
                                        minWidth: column.minWidth,
                                        paddingLeft: column.paddingLeft,
                                      }}
                                      classes={{ root: classes.columnData }}
                                    >
                                      {column.label}
                                    </TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>

                              <TableBody classes={{ root: classes.tBody }}>
                                {bookList?.bookReturn?.length > 0 ? (
                                  bookList?.bookReturn?.map((_el, index) => (
                                    <TableRow
                                      role="checkbox"
                                      tabIndex={-1}
                                      key={index}
                                    >
                                      {columns.map((column) => {
                                        const value = _el[column.id];
                                        //console.log("value", value);
                                        return (
                                          <TableCell
                                            key={column.id}
                                            align={column.align}
                                          >
                                            {column.id === "select" ? (
                                              <Stack
                                                sx={{ alignItems: "center" }}
                                              >
                                                {/* <span>{index + 1}</span> */}
                                                {/* <Radio name={_el.id} checked={selectedValue == _el.id} onChange={()=>handleRadio(_el)} /> */}
                                                {/* </Radio> */}
                                                <Checkbox
                                                  checked={
                                                    selectedValue == _el.id
                                                  }
                                                  onChange={() =>
                                                    handleRadio(_el)
                                                  }
                                                  style={{ color: "#25D5A1" }}
                                                />
                                              </Stack>
                                            ) : column.id === "book" ? (
                                              _el.title
                                            ) : column.id === "author" ? (
                                              _el.author
                                            ) : column.id === "lendDate" ? (
                                              _el.lendDate
                                            ) : column.id === "dueDate" ? (
                                              _el.dueDate
                                            ) : (
                                              ""
                                            )}
                                          </TableCell>
                                        );
                                      })}
                                    </TableRow>
                                  ))
                                ) : (
                                  <TableRow>
                                    <TableCell
                                      colSpan={5}
                                      sx={{ borderBottom: "none" }}
                                    >
                                      <Stack
                                        sx={{
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        No Data
                                      </Stack>
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          )}
                        </TableContainer>
                        {bookList?.totalNoOfRecordsForBooksToReturn?.totalNoOfRecords > 10 && (
                          <CustomPagination
                            count={count}
                            page={page}
                            onPageChange={handleChange}
                            handlePage={handlePage}
                            perPage={PerPage}
                          />
                        )}
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </Paper>
            </Box>
            <LendReturn state={BookData} />
          </Stack>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default LendList;
